// import moment from 'moment-timezone';
import dayjs from 'dayjs';
import JsBarcode from 'jsbarcode';
import {
	// paymentMethods,
	barcodeOptions,
	fragileImage,
} from './statics';
import {
	formatMoney,
	textSplitter,
	duplicateVar,
	getUomByVariation,
} from './helper';

/**
 *
 * @param {*} doc JS Doc Object
 * @param {Object} options Options
 * @param {String[]} instructions Instructions
 */
export const insertInstructions = (doc, options, instructions = []) => {
	const {
		startY = 0,
		// leftX = 0,
		rightX = 0,
		// fontSize = 12,
	} = options;

	let {
		leftX = 0,
	} = options;

	let lastY = startY;

	const dividerOffsetTop = 10;
	lastY += dividerOffsetTop;

	const margin = 10;

	// doc.roundedRect(x, y, w, h, rx, ry, style);
	const boxWidth = rightX - leftX;
	const boxHeight = 38;
	doc.roundedRect(leftX, lastY, boxWidth, boxHeight, 5, 5);

	lastY += 10;

	leftX += 7;

	// Mark Circle
	const radius = 4;
	const circleX = leftX + 3;
	const circleY = lastY - 2;
	doc.circle(circleX, circleY, radius);

	// ! Mark
	const markLeftX = leftX + 2.1;
	const markY = lastY + 0.5;
	doc.text('!', markLeftX, markY);

	// Title
	const title = 'KURIR WAJIB BACA';
	const titleX = leftX + 11;
	doc.setFontType('bold');
	doc.text(title, titleX, lastY);
	doc.setFontType('normal');

	lastY += margin + 2;

	for (let index = 0; index < instructions.length; index++) {
		const instruction = instructions[index];
		const number = index + 1;
		const instructionLabel = `${number}. ${instruction}`;
		doc.text(instructionLabel, leftX, lastY);
		const isNotLast = index < instructions.length - 1;
		if (isNotLast) {
			lastY += margin;
		}
	}

	return lastY;
};

// Generate Barcode
export const generateBarcode = (value, options, canvasId = 'barcode') => {
	const canvas = document.getElementById(canvasId);
	JsBarcode(canvas, value, options);
	const imageData = canvas.toDataURL('image/png');
	return imageData;
};

// Generate Packing Slip
export const generatePackingSlip = (params, packingSlip) => {
	const {
		doc,
		order,
		store,
		isFragile,
		// isShowLogo,
		logo,
		isShowProductInformation,
		isDisplayTotal,
		// isShowPayment,
		// isShowShipping,
		// isShowShippingCost,
		// isShowBarcode,
		isWeightVisible = false,
		// isCodVisible,
		// isCourierVisible = true,
		// isSenderAddressVisible,
		members,
		courierLogos = [],
		settings,
		ooLogo,
		isUnboxingInstructionsVisible,
		isUseProductCode,
		selectedSubmissions,
		isUseProductSupplierName,
		isSenderPhoneVisible,
		baseX = 0,
		// prevBaseY = 0,
		productCodes = [],
	} = params;

	let {
		baseY = 0,
		isShowLogo,
		isShowShipping,
		isShowShippingCost,
		isCodVisible,
		isCourierVisible = true,
		isSenderAddressVisible,
		isShowBarcode,
	} = params;

	let isOoLogoVisible = settings && settings.includes('oo_logo');
	const isNotesVisible = settings && settings.includes('notes');
	const isAddProductCode = settings && settings.includes('add_product_code');
	const isUnboxingInstructions = isUnboxingInstructionsVisible;

	const pageWidth = doc.internal.pageSize.getWidth();
	const pageHeight = doc.internal.pageSize.getHeight();

	let yPosBorder = 0;

	const isStorefront = order.type === 'storefront';
	const isShippingOriginProduct = order.shipping_origin === 'product';

	if (isStorefront && isShippingOriginProduct && !packingSlip) {
		const cartItems = order.cart_items;
		const origins = {};
		cartItems.forEach((item) => {
			const originId = item.origin.id;
			if (!origins[originId]) {
				origins[originId] = {
					items: [item],
					shipping: {},
				};
			} else {
				origins[originId].items.push(item);
			}
		});
		const shippingCosts = order.shipping_costs;
		shippingCosts.forEach((shipping) => {
			const originId = shipping.origin.id;
			if (origins[originId]) {
				origins[originId].shipping = shipping;
			}
		});
		const originsKeys = Object.keys(origins);
		let theBaseX = duplicateVar(baseX);
		let theBaseY = duplicateVar(baseY);
		// let prevBaseY = duplicateVar(baseY);
		for (let index = 0; index < originsKeys.length; index++) {
			params.baseX = theBaseX;
			params.baseY = theBaseY;
			const originsKey = originsKeys[index];
			const origin = origins[originsKey];
			const generatedPosition = generatePackingSlip(params, origin);
			theBaseX = generatedPosition.baseX;
			theBaseY = generatedPosition.baseY;
			// prevBaseY = generatedPosition.prevBaseY || 0;
		}
		yPosBorder = theBaseY;
	} else {
		const defaultLogo = {
			data: '',
			width: 0,
			height: 0,
		};
		const storeLogo = logo || defaultLogo;
		const topPadding = 20;
		const leftPadding = 15;
		// const rightColPos = 320;
		const rightColPos = 270;
		// const lastColPos = 480;
		const lineHeight = 10;
		const newLineMargin = 3;
		// const fragileWidth = 20;
		// const fragileHeight = 40;
		const fragileWidth = 14;
		const fragileHeight = 28;
		// const dim = doc.getTextDimensions('Text');
		// const lineHeight = dim.h;
		// const notesWidth = 320;
		// const logoWidth = 40;
		// const logoHeight = (logoWidth / storeLogo.width) * storeLogo.height;
		// const logoHeight = 35;
		const logoHeight = 20;
		const logoWidth = (logoHeight / storeLogo.height) * storeLogo.width;
		const normalFontSize = 8;

		baseY = baseY && baseY !== '' ? parseInt(baseY) : 0;

		const yPos = baseY + topPadding;
		const yPosName = yPos + lineHeight + newLineMargin;
		let yPosAddress = yPosName + lineHeight + newLineMargin;
		let yPosAddressDetails = yPosAddress + lineHeight;
		let yPosPhone = yPosAddressDetails + lineHeight + newLineMargin;

		// const orderId = order.order_id;
		const customer = order.customer_data;
		const variation = customer.variation ? customer.variation : '';
		const variations = customer.variations ? customer.variations : [];
		const address = customer.address ? customer.address.replace(/[\r\n]+/gm, ' ') : '';
		// const addressLines = textSplitter(address, 70);
		const addressLength = 55;
		const addressLines = textSplitter(address, addressLength);
		// const productName = order.product_name;
		let productName = order.product_name || '';
		if (order.product_data) {
			productName = order.product_data.name;
		}
		const quantityValue = customer.quantity || 1;
		const productQuantity = `(x${quantityValue})`;
		let productText = variations.length > 0 ? productName : `${productName} ${productQuantity}`;
		const paymentMethod = order.payment && order.payment.method && order.payment.method !== '' ? order.payment.method : 'bank_transfer';
		const isCod = paymentMethod === 'cod';
		// eslint-disable-next-line camelcase
		// const isShippingCostDeducted = order?.payment?.shipping_deducted ?? false;
		// const isInstant = paymentMethod === 'instant' && isShippingCostDeducted;
		const isForm = order.type === 'form';
		const hasBump = order.bump && order.bump.checked;
		const bumpWeight = order.bump && order.bump.weight ? order.bump.weight : 0;
		const defaultWeight = 1000;
		let totalWeight = defaultWeight;
		const grossRevenue = order.gross_revenue || order.total_price;

		// Calculate Total Weight
		if (isForm) {
			if (variations.length > 0) {
				totalWeight = 0;
				// Multiple Variations
				variations.forEach((variationItem) => {
					const variationWeight = variationItem.weight * variationItem.quantity;
					totalWeight += variationWeight;
				});
			} else {
				// Simple Product / Single Variable
				const singleQty = customer.quantity || 1;
				const singleProductWeight = order.product_weight * singleQty;
				totalWeight = singleProductWeight;
			}
		} else {
			let orderCartItems = [];
			orderCartItems = packingSlip && packingSlip.items ? packingSlip.items : [];
			if (order.cart_items) {
				orderCartItems = order.cart_items;
			}
			orderCartItems.forEach((item, index) => {
				if (index === 0) {
					totalWeight = 0;
				}
				const cartItemWeight = item.weight * item.qty;
				totalWeight += cartItemWeight;
			});
		}

		// Bump Weight
		if (hasBump) {
			totalWeight += bumpWeight;
		}

		const bumpName = hasBump ? `${order.bump.name} (x1)` : '';

		const addressDetails = [];

		const subdistrict = customer.district ? customer.district : customer.subdistrict_name;
		const subdistrictLabel = `Kec. ${subdistrict}`;

		if (subdistrict && subdistrict !== '') {
			addressDetails.push(subdistrictLabel);
		}

		if (customer.city) {
			addressDetails.push(customer.city);
		} else if (customer.city_name) {
			addressDetails.push(customer.city_name);
		}

		const addressDetailsString = addressDetails.join(', ');

		const phone = customer.phone ? `Telp: ${customer.phone}` : '';
		let storeName = store.name ? store.name : '';
		let storePhone = '';
		if (isSenderPhoneVisible) {
			storePhone = store.phone ? store.phone : '';
		}
		// const storeWebsite = store.website ? store.website : '';
		// Dropship
		const isDropship = order.dropship && order.dropship.enabled;
		const dropshipperName = isDropship ? order.dropship.name : '';
		const dropshipperPhone = isDropship ? order.dropship.phone : '';

		if (isDropship) {
			isShowLogo = false;
			storeName = dropshipperName;
			storePhone = dropshipperPhone;
			isSenderAddressVisible = false;
		}

		const csId = order.belongs_to && order.belongs_to.length > 0 ? order.belongs_to[0].$oid : 0;
		const customerService = members.find(({ _id }) => _id === csId);
		const csName = customerService ? customerService.name : '';
		const csPhone = customerService ? customerService.phone : '';

		const replacements = [
			{ key: 'cs_name', value: csName },
			{ key: 'cs_phone', value: csPhone },
		];

		for (let index = 0; index < replacements.length; index++) {
			const replacement = replacements[index];
			const token = `{{${replacement.key}}}`;
			const regex = new RegExp(token, 'g');
			storeName = storeName.replace(regex, replacement.value);
			storePhone = storePhone.replace(regex, replacement.value);
		}

		const orderDateFormat = 'DD-MM-YYYY';
		const orderDate = dayjs(order.created_at).format(orderDateFormat);
		const orderId = `Order #${order.order_id} (${orderDate})`;

		let shippingCourier = order.shipping.courier || '';
		let shipment = order.shipping.courier ? `${order.shipping.courier.toUpperCase()} - ${order.shipping.service}` : '';
		let shippingCost = order.shipping.cost;
		const receiptNumber = order.shipping.receipt_number && order.shipping.receipt_number !== '' ? order.shipping.receipt_number : false;
		const receiptLabel = `NO. RESI: ${order.shipping.receipt_number}`;

		// Check The Mandatory Items
		// const isMandatory = (shippingCourier === 'sicepat' || shippingCourier === 'jne') && (isCod || isInstant);
		// const isPartnerCourier = (shippingCourier === 'sicepat' || shippingCourier === 'jne' || shippingCourier === 'J&T' || shippingCourier === 'sap');
		// const isValidBankTransfer = paymentMethod === 'bank_transfer' && (order.shipping && order.shipping.pickup);
		// const isMandatory = isPartnerCourier && (isCod || isInstant || isValidBankTransfer);
		const isOrderPickedUp = order && order.shipping && !!order.shipping.pickup;
		const isMandatory = isOrderPickedUp;

		// Force these options if courier is SiCepat and Payment Method is COD
		if (!isCourierVisible) {
			isCourierVisible = isMandatory;
		}
		if (!isOoLogoVisible) {
			isOoLogoVisible = isMandatory;
		}
		if (!isCodVisible) {
			isCodVisible = isMandatory;
		}
		if (!isShowBarcode) {
			isShowBarcode = isMandatory;
		}
		// if (!isSenderAddressVisible) {
		// 	isSenderAddressVisible = isMandatory;
		// }
		if (!isShowShipping) {
			isShowShipping = isMandatory;
		}
		if (isShowShippingCost && isMandatory) {
			isShowShippingCost = false;
		}

		if (packingSlip) {
			shippingCourier = packingSlip.shipping.courier || '';
			shipment = packingSlip.shipping.courier ? `${packingSlip.shipping.courier.toUpperCase()} - ${packingSlip.shipping.service}` : '';
			shippingCost = packingSlip.shipping.cost;
		}

		let notes = customer.notes || '';
		// let notesLines = notes ? doc.splitTextToSize(notes, notesWidth) : [];
		notes = notes.replace(/(?:\r\n|\r|\n)/g, '. '); // Replace New Line with period
		// const maxChar = 40;
		const maxChar = 34;
		let notesLines = notes ? textSplitter(notes, maxChar) : [];
		notesLines = notesLines.length > 3 ? notesLines.slice(0, 3) : notesLines;

		doc.setFontSize(normalFontSize);

		doc.setFontType('bold');
		doc.text('Kepada:', leftPadding, yPos);

		doc.setFontType('normal');

		// Customer Name
		doc.text(customer.name, leftPadding, yPosName);

		// Customer Address
		// doc.text(address, leftPadding, yPosAddress);
		for (let index = 0; index < addressLines.length; index++) {
			const line = addressLines[index];
			doc.text(line, leftPadding, yPosAddress);
			if (index !== addressLines.length - 1) {
				yPosAddress += lineHeight;
			}
		}

		yPosAddressDetails = yPosAddress + lineHeight;

		// Customer Address Subdistrict and City
		// doc.text(addressDetailsString, leftPadding, yPosAddressDetails);
		const addressDetailsLines = textSplitter(addressDetailsString, addressLength);
		for (let index = 0; index < addressDetailsLines.length; index++) {
			const line = addressDetailsLines[index];
			doc.text(line, leftPadding, yPosAddressDetails);
			if (index !== addressDetailsLines.length - 1) {
				yPosAddressDetails += lineHeight;
			}
		}

		yPosAddressDetails += lineHeight;

		const provinceName = customer.province_name;
		const zipCode = customer.zip || '';
		const provinceLabel = provinceName ? `${customer.province_name} ${zipCode}` : `${zipCode}`;

		yPosPhone = yPosAddressDetails;

		// Customer Province
		if (provinceLabel && provinceLabel !== '') {
			doc.text(provinceLabel, leftPadding, yPosAddressDetails);
			yPosPhone = yPosAddressDetails + lineHeight;
		}

		// Customer Phone
		doc.text(phone, leftPadding, yPosPhone);

		// Payment Position
		// let yPosPayment = yPosPhone + topPadding;

		// Shipping
		let yPosSender = yPosPhone + topPadding;
		let yPosShippingCost = yPosSender + lineHeight + newLineMargin;
		let yPosReceiptNumber = yPosShippingCost + lineHeight + newLineMargin;

		const yPosOrderId = baseY + topPadding;
		let yPosProductName = yPosOrderId + lineHeight + newLineMargin;
		let yPosProductVariation = yPosProductName + lineHeight + newLineMargin;

		// let yPosFragile = baseY + topPadding + lineHeight + 3;
		// let yPosFragileTitle = yPosFragile + fragileHeight + lineHeight + newLineMargin;
		// let yPosFragileContent = yPosFragileTitle + lineHeight;
		// const yPosFragileContent2 = yPosFragileContent + lineHeight;

		const xPosOrderId = rightColPos;
		const xPosStore = isShowLogo ? leftPadding + logoWidth + 10 : leftPadding;
		// const xSender = isShowLogo ? leftPadding + logoWidth + 10 : leftPadding;
		const xSender = leftPadding;

		// let xPosFragile = lastColPos + 5 + 30;
		// let xPosFragileTitle = lastColPos + 5 + 16;
		// let xPosFragileContent = lastColPos + 5;

		// const xPosTotal = lastColPos;
		// const xPosTotal = pageWidth - leftPadding;
		// const yPosTotal = yPosOrderId;

		const xPosLogo = leftPadding;
		const yPosLogo = yPosSender + 7;

		let yPosNotes = receiptNumber ? yPosReceiptNumber + lineHeight + newLineMargin : yPosReceiptNumber;
		let yPosNotesContent = yPosNotes + lineHeight;

		let yPosBump = 0;
		let yPosWeight = yPosShippingCost;

		// Store Logo
		const isStoreLogoVisible = isShowLogo && storeLogo && storeLogo.data && storeLogo.data !== '' && !isDropship;
		if (isStoreLogoVisible) {
			doc.addImage(storeLogo.data, 'PNG', xPosLogo, yPosLogo, logoWidth, logoHeight);
		}

		// Sender
		doc.setFontType('bold');
		doc.text('Pengirim:', xSender, yPosSender);

		doc.setFontType('normal');

		const storeProvince = store.shipping.origin.province ? store.shipping.origin.province.name : '';
		const storeCity = store.shipping.origin.city ? store.shipping.origin.city.name : '';
		const storeSubdistrict = store.shipping.origin.subdistrict ? store.shipping.origin.subdistrict.name : '';
		const storeZip = store.shipping.origin.zip || '';
		const storeAddress = store.address || '';
		const storeAddressDetails = `${storeSubdistrict}, ${storeCity}`;
		const storeAddressProvince = `${storeProvince} ${storeZip}`;

		const yPosStoreName = yPosSender + lineHeight + newLineMargin;
		// const yPosStoreWeb = yPosStoreName + lineHeight + newLineMargin;
		let yPosStoreAddress = yPosStoreName + lineHeight + newLineMargin;

		// Store Name
		doc.text(storeName, xPosStore, yPosStoreName);

		let yPosStorePhone = yPosStoreName + lineHeight;
		if (isSenderAddressVisible) {
			// Store Website
			// doc.text(storeWebsite, xPosStore, yPosStoreWeb);
			const storeAddressCharacters = isStoreLogoVisible ? 35 : 50;

			// Store Address
			// doc.text(storeAddress, xPosStore, yPosStoreAddress);

			// Store Address
			const storeAddressLines = textSplitter(storeAddress, storeAddressCharacters);
			for (let index = 0; index < storeAddressLines.length; index++) {
				const line = storeAddressLines[index];
				doc.text(line, xPosStore, yPosStoreAddress);
				if (index !== storeAddressLines.length - 1) {
					yPosStoreAddress += lineHeight;
				}
			}

			let yPosStoreAddressDetails = yPosStoreAddress + lineHeight;

			// Store Address Details
			// doc.text(storeAddressDetails, xPosStore, yPosStoreAddressDetails);
			const storeAddressDetailsLines = textSplitter(storeAddressDetails, storeAddressCharacters);
			for (let index = 0; index < storeAddressDetailsLines.length; index++) {
				const line = storeAddressDetailsLines[index];
				doc.text(line, xPosStore, yPosStoreAddressDetails);
				if (index !== storeAddressDetailsLines.length - 1) {
					yPosStoreAddressDetails += lineHeight;
				}
			}

			const yPosStoreAddressProvince = yPosStoreAddressDetails + lineHeight;
			yPosStorePhone = yPosStoreAddressProvince + lineHeight;

			// Store Address Province
			doc.text(storeAddressProvince, xPosStore, yPosStoreAddressProvince);
		}

		// Store Phone
		doc.text(storePhone, xPosStore, yPosStorePhone);

		yPosBorder = yPosStorePhone + topPadding;

		// Order ID
		doc.setFontType('bold');
		doc.text(orderId, xPosOrderId, yPosOrderId);

		doc.setFontType('normal');

		// Product Information
		if (isShowProductInformation) {
			// const isHideProductName = settings && settings.includes('hide_product_name');
			const isHideProductName = isUseProductCode;
			if (order.type === 'form') {
				// Use Product Code
				if (isHideProductName) {
					const productSourceId = order?.product_data?.source_id ?? '';
					const theProductCode = productCodes.find(({ _id }) => _id === productSourceId);
					if (theProductCode) {
						productText = `${theProductCode.code} ${productQuantity}`;
					}
				}

				if (isAddProductCode) {
					productText = `${productText} - ${order?.product_data.code ?? ''}`;
				}

				if (isUseProductSupplierName) {
					const submission = selectedSubmissions.find(sub => sub._id === order._id);
					productText = `${submission?.product_name}`;
					if (isAddProductCode) {
						productText = `${productText} - ${submission?.product_code ?? ''}`;
					}
				}


				// Product Name
				doc.text(productText, rightColPos, yPosProductName);

				doc.setTextColor(0, 0, 0);

				// Product Variation
				doc.setFontSize(7);

				if (!isHideProductName) {
					if (variations.length > 0) {
						// Multiple Variations
						variations.forEach((variationItem) => {
							const variationItemLabel = `${variationItem.value} (x${variationItem.quantity})`;
							doc.text(variationItemLabel, rightColPos, yPosProductVariation);
							yPosProductVariation += lineHeight;
						});
					} else {
						// Single Variation
						doc.text(variation, rightColPos, yPosProductVariation);
						yPosProductVariation += lineHeight;
					}
				}

				// Bump
				yPosBump = yPosProductVariation + newLineMargin + 3;
				yPosBump = variation === '' && variations.length === 0 ? yPosProductVariation : yPosBump;

				doc.setFontSize(normalFontSize);
				doc.text(bumpName, rightColPos, yPosBump);
			} else {
				const orderCartItems = packingSlip ? packingSlip.items : order.cart_items;
				const submission = selectedSubmissions.find(sub => sub._id === order._id);
				orderCartItems.forEach((item) => {
					const productSupplier = submission?.products?.find(sub => sub?.product_id?.$oid === item?.source_id);
					const hasVariation = !!item.variation;
					let cartItemProductText = hasVariation ? item.product_name : `${item.product_name} (x${item.qty})`;
					const cartItemProductVariation = hasVariation ? `${item.variation.replace(/\|\|/g, ' - ')} (x${item.qty})` : '';

					doc.setFontSize(normalFontSize);

					const itemOffsetTop = 0;

					// Use Product Code
					if (isHideProductName) {
						// eslint-disable-next-line camelcase
						const productSourceId = item?.source_id ?? '';
						const theProductCode = productCodes.find(({ _id }) => _id === productSourceId);
						if (theProductCode) {
							cartItemProductText = `${theProductCode.code} (x${item.qty})`;
						}
					}

					if (isUseProductSupplierName) {
						cartItemProductText = hasVariation
							? productSupplier.name : `${productSupplier.name} (x${item.qty})`;
					}
					// Product Name
					doc.text(cartItemProductText, rightColPos, yPosProductName);
					yPosProductName += lineHeight + itemOffsetTop;

					if (!isHideProductName) {
						if (hasVariation) {
							yPosProductVariation = yPosProductName;
							// Product Variation
							doc.setFontSize(7);
							// Variation
							doc.text(cartItemProductVariation, rightColPos, yPosProductVariation);
							yPosProductName = yPosProductVariation + lineHeight + itemOffsetTop;
						}

						// Item Notes
						if (item.notes && item.notes !== '') {
							const itemNotes = `Catatan: ${item.notes}`;
							// Variation
							doc.text(itemNotes, rightColPos, yPosProductName);
							yPosProductName = yPosProductName + lineHeight + itemOffsetTop;
						}

						yPosProductVariation = yPosProductName + lineHeight;
					}
					yPosProductName += lineHeight + itemOffsetTop;
				});
			}
		}

		// Bump Position
		if (yPosSender <= yPosBump) {
			// yPosPayment = yPosBump + lineHeight + newLineMargin + 3;
			yPosSender = yPosBump + lineHeight + newLineMargin + 3;
			yPosShippingCost = yPosSender + lineHeight + newLineMargin;
			yPosReceiptNumber = yPosShippingCost + lineHeight + newLineMargin;
			yPosNotes = receiptNumber ? yPosReceiptNumber + lineHeight + newLineMargin : yPosReceiptNumber;
			yPosNotesContent = yPosNotes + lineHeight;
		}


		// Payment
		// if (isShowPayment) {
		// 	const paymentMethodLabel = paymentMethods[paymentMethod];
		// 	const paymentText = `Pembayaran: ${paymentMethodLabel}`;

		// 	doc.setFontSize(8);
		// 	doc.setFontType('bold');
		// 	doc.text(paymentText, rightColPos, yPosPayment);

		// 	yPosProductVariation = yPosPayment + lineHeight + newLineMargin;
		// 	yPosSender += lineHeight + newLineMargin;
		// 	yPosShippingCost += lineHeight + newLineMargin;
		// 	yPosReceiptNumber += lineHeight + newLineMargin;
		// 	yPosNotes = receiptNumber ? yPosReceiptNumber + lineHeight + newLineMargin : yPosReceiptNumber;
		// 	yPosNotesContent = yPosNotes + lineHeight;
		// }

		const ooLogoHeight = 18;
		const ooLogoWidth = ooLogo ? (ooLogoHeight / ooLogo.height) * ooLogo.width : 0;
		const ooLogoX = pageWidth - leftPadding - ooLogoWidth;
		let ooLogoY = baseY + topPadding - 10;

		const isHasOoLogo = isOoLogoVisible && ooLogo;

		// Get Courier Logo
		if (shippingCourier === 'J&T') shippingCourier = 'jnt';
		const courierLogo = courierLogos.find(({ key }) => key === shippingCourier);
		const courierLogoWidth = 60;
		const courierLogoHeight = courierLogo ? (courierLogoWidth / courierLogo.width) * courierLogo.height : 0;
		// const xPosCourierLogo = pageWidth - 70 - (courierLogoWidth / 2);
		const xPosCourierLogo = pageWidth - courierLogoWidth - leftPadding;
		let yPosCourierLogo = baseY + topPadding + lineHeight + 5;

		const xPosCodLabel = pageWidth - leftPadding;
		const yPosCodLabel = Number(yPosOrderId);
		// const newHeight = ooLogoY + ooLogoHeight + lineHeight + 9;
		// const yPosCodLabel = isHasOoLogo ? newHeight : Number(yPosOrderId);

		const logoMargin = 10;

		// COD Label
		if (isCodVisible) {
			doc.setFontType('bold');
			const orderTotal = formatMoney(grossRevenue, 'IDR', true);
			const codLabel = isCod ? `COD: ${orderTotal}` : 'NON-COD';
			const codFontSize = 14;
			doc.setFontSize(codFontSize);
			doc.text(codLabel, xPosCodLabel, yPosCodLabel, { align: 'right' });
			doc.setFontSize(normalFontSize);
			doc.setFontType('normal');

			yPosCourierLogo = yPosCodLabel + codFontSize;
			ooLogoY += codFontSize + logoMargin;
		}

		// Ostock Logo
		if (isHasOoLogo) {
			doc.addImage(ooLogo.data, 'PNG', ooLogoX, ooLogoY, ooLogoWidth, ooLogoHeight);
			yPosCourierLogo += ooLogoHeight + logoMargin;
		}

		// Shipment
		if (isShowShipping) {
			const yPosCourier = isStorefront && (yPosProductVariation > yPosSender) ? yPosProductVariation : yPosSender;

			if (isStorefront) {
				yPosShippingCost = yPosCourier + lineHeight + newLineMargin;
				yPosReceiptNumber = yPosShippingCost + lineHeight + newLineMargin;
				yPosNotes = receiptNumber ? yPosReceiptNumber + lineHeight + newLineMargin : yPosReceiptNumber;
				yPosNotesContent = yPosNotes + lineHeight;
			}

			doc.setFontSize(8);
			doc.setFontType('bold');
			doc.text(shipment, rightColPos, yPosCourier);

			// Shipping Cost
			if (isShowShippingCost && shippingCost && shippingCost !== 0) {
				const shippingCostLabel = `Ongkir: ${formatMoney(shippingCost, 'IDR', true)}`;
				doc.setFontType('normal');
				doc.text(shippingCostLabel, rightColPos, yPosShippingCost);
			}

			// Weight
			if (isWeightVisible) {
				const isCeil = totalWeight % 1000 > 300;
				const weightKg = totalWeight / 1000;
				let totalWeightKg = isCeil ? Math.ceil(weightKg) : Math.floor(weightKg);
				if (totalWeightKg <= 0) totalWeightKg = 1;
				const weightLabel = `Berat: ${totalWeightKg} Kg`;
				yPosWeight = isShowShippingCost ? yPosShippingCost + lineHeight + newLineMargin : yPosShippingCost;
				doc.setFontType('normal');
				doc.text(weightLabel, rightColPos, yPosWeight);

				yPosReceiptNumber = yPosWeight + lineHeight + newLineMargin;
				yPosNotes = receiptNumber ? yPosReceiptNumber + lineHeight + newLineMargin : yPosReceiptNumber;
				yPosNotesContent = yPosNotes + lineHeight;
			}

			// let ooLogoX = pageWidth - leftPadding - ooLogoWidth;
			// const ooLogoY = yPosCourierLogo - 2;

			// Courier Logo
			if (isCourierVisible && courierLogo) {
				doc.addImage(courierLogo.data, 'PNG', xPosCourierLogo, yPosCourierLogo, courierLogoWidth, courierLogoHeight);
				// ooLogoX = xPosCourierLogo - leftPadding - ooLogoWidth;
			}
		}

		const isInsuranceVisible = shippingCourier === 'sicepat';
		let lastY = yPosReceiptNumber;

		// Insurance
		if (isInsuranceVisible) {
			const xPosInsurance = rightColPos;
			const yPosInsurance = lastY;
			const insuranceValue = 0;
			const insuranceLabel = `Asuransi: ${insuranceValue}`;
			doc.text(insuranceLabel, xPosInsurance, yPosInsurance);

			lastY += lineHeight + newLineMargin;
		}

		// Total
		if (isDisplayTotal) {
			const xPosTotal = rightColPos;
			const yPosTotal = lastY;
			const orderTotal = formatMoney(grossRevenue, 'IDR', true);
			// doc.setFontSize(10);
			const orderTotalLabel = `Total: ${orderTotal}`;
			doc.text(orderTotalLabel, xPosTotal, yPosTotal);
			// doc.setFontSize(normalFontSize);

			lastY += lineHeight + newLineMargin;

			// yPosReceiptNumber = yPosTotal + lineHeight + newLineMargin;
			// yPosNotes = receiptNumber ? yPosReceiptNumber + lineHeight + newLineMargin : yPosReceiptNumber;
			// yPosNotesContent = yPosNotes + lineHeight;
		}

		// Show Receipt Number
		lastY += lineHeight + newLineMargin;
		if (receiptNumber && !isShowBarcode) {
			doc.setFontType('normal');
			// doc.text(receiptLabel, rightColPos, yPosReceiptNumber);
			doc.text(receiptLabel, rightColPos, lastY);
		}

		// Notes
		if (isNotesVisible && notesLines.length > 0) {
			yPosNotes = Number(lastY);
			yPosNotesContent = yPosNotes + lineHeight;

			doc.setFontType('bold');
			doc.text('Catatan:', rightColPos, yPosNotes);
			doc.setFontType('normal');
			for (let index = 0; index < notesLines.length; index++) {
				const line = notesLines[index];
				doc.text(line, rightColPos, yPosNotesContent);
				yPosNotesContent += lineHeight;
			}

			lastY = Number(yPosNotesContent);
		}

		if (yPosBorder <= lastY) {
			yPosBorder = lastY + 5;
		}

		doc.setFontType('bold');

		// Fragile Sign
		if (isFragile) {
			const marginRight = 120;
			const xPosFragile = rightColPos + marginRight + 30;
			const xPosFragileTitle = rightColPos + marginRight + 20;
			// const xPosFragileContent = rightColPos + marginRight;

			const yPosFragile = yPosBorder - topPadding - fragileHeight - 5;
			const yPosFragileTitle = yPosFragile + fragileHeight + lineHeight + newLineMargin;
			// const yPosFragile = isShowPayment ? yPosPayment - 4 : yPosSender - 4;
			// const yPosFragileTitle = yPosFragile + fragileHeight + lineHeight + newLineMargin;
			// const yPosFragileContent = yPosFragileTitle + lineHeight;

			doc.addImage(fragileImage, 'PNG', xPosFragile, yPosFragile, fragileWidth, fragileHeight);
			// doc.setFontSize(9);
			doc.text('FRAGILE', xPosFragileTitle, yPosFragileTitle);
			doc.setFontSize(normalFontSize);
			// doc.text('JANGAN DIBANTING!!', xPosFragileContent, yPosFragileContent);
		}

		// Order Barcode
		let yLastPosAwb = yPosBorder - 35 - 13;
		let yLastBarcodeId = yPosBorder - 10;
		if (isShowBarcode) {
			const barcodeValue = order.order_id;
			const barcodeImage = generateBarcode(barcodeValue, barcodeOptions);
			const barcodeWidth = 90;
			const barcodeHeight = 35;
			const barcodeAwbWidth = 100;
			const barcodeAwbHeight = 35;

			if (receiptNumber) {
				// const topHeight = 20;
				const magicNumber = 10 - 3 - 13 - 3;
				const yTreshold = yPosBorder - (barcodeHeight + barcodeAwbHeight + (lineHeight * 2) - magicNumber);
				const diffHeight = (yPosCourierLogo + courierLogoHeight) - yTreshold;
				const isCrossing = diffHeight > 0;
				if (isCrossing) {
					yPosBorder += (diffHeight * 1);
				}
			}

			// const xPosBarcode = lastColPos;
			const xPosBarcodeId = pageWidth - leftPadding;
			const yPosBarcodeId = yPosBorder - 10;
			const xPosBarcode = pageWidth - leftPadding - barcodeWidth;
			const yPosBarcode = yPosBarcodeId - barcodeHeight - 3;
			// const yPosBarcode = yPosFragileContent;
			doc.addImage(barcodeImage, 'PNG', xPosBarcode, yPosBarcode, barcodeWidth, barcodeHeight);
			doc.text(`Order ID: ${order.order_id}`, xPosBarcodeId, yPosBarcodeId, { align: 'right' });

			yLastBarcodeId = yPosBarcodeId;

			// AWB / No. Resi
			if (receiptNumber) {
				const barcodeAwbOptions = Object.assign({}, barcodeOptions, { displayValue: false });
				const barcodeAwbImage = generateBarcode(receiptNumber, barcodeAwbOptions);
				const xPosAwb = pageWidth - leftPadding;
				const yPosAwb = yPosBorder - barcodeHeight - 13;
				const xPosBarcodeAwb = pageWidth - leftPadding - barcodeAwbWidth;
				const yPosBarcodeAwb = yPosAwb - barcodeAwbHeight - 3;
				// const yPosBarcodeAwb = yPosFragileContent;
				doc.addImage(barcodeAwbImage, 'PNG', xPosBarcodeAwb, yPosBarcodeAwb, barcodeAwbWidth, barcodeAwbHeight);
				doc.text(`Resi: ${receiptNumber}`, xPosAwb, yPosAwb, { align: 'right' });
				yLastPosAwb = yPosAwb;
			}
		}

		doc.setFontType('normal');

		// Unboxing Instructions
		let yUnboxingInstructions = receiptNumber ? yLastPosAwb + 20 : yLastBarcodeId;

		if (!receiptNumber) {
			yUnboxingInstructions = yPosBorder;
			yPosBorder += 30;
		}
		if (isUnboxingInstructions) {
			const unboxingText = 'WAJIB VIDEO UNBOXING UNTUK KLAIM';
			doc.setFontType('bold');
			doc.setFontSize(12);
			doc.setTextColor(255, 0, 0);
			doc.text(unboxingText, 160, yUnboxingInstructions);
			doc.setTextColor(0, 0, 0);
		}

		// Border Bottom
		doc.line(0, yPosBorder, 900, yPosBorder);

		// Check if need to add page
		const oneFourthPageHeight = pageHeight / 4;
		const isNeedNewPage = yPosBorder >= (pageHeight - oneFourthPageHeight);
		if (isNeedNewPage) {
			doc.addPage();
			yPosBorder = 0;
		}
	}

	// return yPosBorder;

	const generated = {
		baseX,
		baseY: yPosBorder,
	};

	return generated;
};

const adjustUnboxingText = (doc, template, shippingCourier, isUnboxingInstructions, instructions, lastY, lineHeight, leftPos) => {
	doc.setTextColor(255, 0, 0);
	const unboxingText = 'WAJIB VIDEO UNBOXING UNTUK KLAIM';
	let unboxingTextY = lastY + 3;
	let unboxingTextX = leftPos + 80;
	let lastUnboxingY = unboxingTextY;

	doc.setFontSize(6);
	doc.setFontType('bold');

	if (isUnboxingInstructions) {
		switch (template) {
		case 'thermal':
			unboxingTextX -= 15;
			break;

		case 'boxed':
			break;

		case 'thermal-small':
			doc.setFontType('bold');
			doc.setFontSize(4);
			unboxingTextX -= 35;
			unboxingTextY -= 10;
			lastUnboxingY += 75;

			if (shippingCourier === 'idexpress') {
				unboxingTextX -= 6;
			}
			if (shippingCourier === 'sap') {
				unboxingTextX -= 6;
			}
			break;

		case 'thermal-large':
			unboxingTextX -= 10;
			if (!instructions.length > 0) {
				unboxingTextY -= 10;
			}
			break;

		default:
			break;
		}


		doc.text(unboxingText, unboxingTextX, unboxingTextY);
		doc.setTextColor(0, 0, 0);
		return lastUnboxingY;
	}

	doc.setFontType('normal');
	doc.setTextColor(0, 0, 0);
	return lastY;
};
// Generate Packing Slip - Thermal
export const generatePackingSlipThermal = (params, packingSlip) => {
	const {
		doc,
		order,
		store,
		// isFragile,
		// isShowLogo,
		logo,
		isShowProductInformation,
		isDisplayTotal,
		// isShowPayment,
		// isShowShipping,
		// isShowShippingCost,
		// isShowBarcode,
		isWeightVisible = false,
		// isCodVisible,
		// isCourierVisible = true,
		// isSenderAddressVisible,
		isSenderPhoneVisible,
		isUnboxingInstructionsVisible,
		isUseProductCode,
		isUseProductSupplierName,
		isUsePcsInformation,
		selectedSubmissions,
		members,
		courierLogos = [],
		settings,
		ooLogo,
		pageFormat,
		template,
		// isLast = false,
		labelData = null,
		productCodes = [],
		isLast = false,
		instructions = [],
	} = params;

	const isFragile = false;
	const isThermal = template === 'thermal' || template === 'thermal-small' || template === 'thermal-large';
	const isSmall = template === 'thermal-small'; // Layout 4
	const isAddProductCode = settings && settings.includes('add_product_code');
	const isUnboxingInstructions = isUnboxingInstructionsVisible;

	let {
		baseX = 0,
		baseY = 0,
		prevBaseY = 0,
		isShowLogo,
		isShowShipping,
		isShowShippingCost,
		isCodVisible,
		isCourierVisible = true,
		isSenderAddressVisible,
		isShowBarcode,
	} = params;

	baseX = baseX && baseX !== '' ? parseInt(baseX) : 0;
	baseY = baseY && baseY !== '' ? parseInt(baseY) : 0;

	// const prevBaseY = Number(baseY);

	let isOoLogoVisible = settings && settings.includes('oo_logo');
	const isNotesVisible = settings && settings.includes('notes');
	// const isHideProductName = settings && settings.includes('hide_product_name');
	const isHideProductName = isUseProductCode;

	const pageWidth = doc.internal.pageSize.getWidth();
	const pageHeight = doc.internal.pageSize.getHeight();

	let yPosBorder = 0;

	const isStorefront = order.type === 'storefront';
	const isShippingOriginProduct = order.shipping_origin === 'product';

	let generated = {
		baseX,
		baseY,
		prevBaseY,
	};

	if (isStorefront && isShippingOriginProduct && !packingSlip) {
		const cartItems = order.cart_items;
		const origins = {};
		cartItems.forEach((item) => {
			const originId = item.origin.id;
			if (!origins[originId]) {
				origins[originId] = {
					items: [item],
					shipping: {},
				};
			} else {
				origins[originId].items.push(item);
			}
		});
		const shippingCosts = order.shipping_costs;
		shippingCosts.forEach((shipping) => {
			const originId = shipping.origin.id;
			if (origins[originId]) {
				origins[originId].shipping = shipping;
			}
		});
		const originsKeys = Object.keys(origins);
		let theBaseX = Number(baseX);
		let theBaseY = Number(baseY);
		// const originsLength = originsKeys.length;
		for (let index = 0; index < originsKeys.length; index++) {
			params.baseX = theBaseX;
			params.baseY = theBaseY;
			params.prevBaseY = prevBaseY;
			// params.isLast = index === originsLength - 1;
			const originsKey = originsKeys[index];
			const origin = origins[originsKey];
			const generatedPosition = generatePackingSlipThermal(params, origin);
			theBaseX = generatedPosition.baseX;
			theBaseY = generatedPosition.baseY;
			prevBaseY = generatedPosition.prevBaseY || 0;

			generated = duplicateVar(generatedPosition);
		}
		yPosBorder = theBaseY;
	} else {
		let shippingCourier = order.shipping.courier || '';
		const defaultLogo = {
			data: '',
			width: 0,
			height: 0,
		};
		const storeLogo = logo || defaultLogo;
		const topPadding = isSmall ? 3 : 10;
		const leftPadding = isSmall ? 3 : 10;
		const rightColPos = 270;
		// const lineHeight = 10;
		const lineHeight = isSmall ? 5.5 : 8.5;
		const newLineMargin = isSmall ? 1 : 3;
		const fragileWidth = 14;
		const fragileHeight = 28;
		const logoWidth = 30;
		const logoHeight = (logoWidth / storeLogo.width) * storeLogo.height;
		// const normalFontSize = 8;
		let normalFontSize = 7;
		if (isSmall) {
			normalFontSize = 5;
		}

		// Unboxing Instructions Thermal
		// adjustUnboxingText(doc, template, isShowProductInformation, isUnboxingInstructions, instructions);

		doc.setTextColor(0, 0, 0);

		// const orderId = order.order_id;
		const customer = order.customer_data;
		const variation = customer.variation ? customer.variation : '';
		const variations = customer.variations ? customer.variations : [];
		const address = customer.address ? customer.address.replace(/[\r\n]+/gm, ' ') : '';
		const addressCharacters = 30;
		const addressLines = textSplitter(address, addressCharacters);
		let productName = order.product_name || '';
		if (order.product_data) {
			productName = order.product_data.name;
		}
		if (isUseProductSupplierName) {
			const submission = selectedSubmissions.find(sub => sub._id === order._id);
			productName = `${submission?.product_name}`;
		}
		let quantityValue = customer.quantity || 1;

		if (isUsePcsInformation) {
			quantityValue = order?.product_data?.uom?.value ?? 1;
		}

		const productQuantity = `(x${quantityValue})`;
		const productText = variations.length > 0 ? productName : `${productName} ${productQuantity}`;
		const paymentMethod = order.payment && order.payment.method && order.payment.method !== '' ? order.payment.method : 'bank_transfer';
		const isCod = paymentMethod === 'cod';
		// eslint-disable-next-line camelcase
		// const isShippingCostDeducted = order?.payment?.shipping_deducted ?? false;
		// const isInstant = paymentMethod === 'instant' && isShippingCostDeducted;
		const isForm = order.type === 'form';
		const hasBump = order.bump && order.bump.checked;
		const bumpWeight = order.bump && order.bump.weight ? order.bump.weight : 0;
		const defaultWeight = 1000;
		let totalWeight = defaultWeight;
		const grossRevenue = order.gross_revenue || order.total_price;
		let totalPcsProduct = 0;

		// Calculate Total Weight
		if (isForm) {
			if (variations.length > 0) {
				totalWeight = 0;
				// Multiple Variations
				variations.forEach((variationItem) => {
					const variationWeight = variationItem.weight * variationItem.quantity;
					totalWeight += variationWeight;
				});
			} else {
				// Simple Product / Single Variable
				const singleQty = customer.quantity || 1;
				const singleProductWeight = order.product_weight * singleQty;
				totalWeight = singleProductWeight;
				totalPcsProduct = order.product_data?.uom?.value ?? 1;
			}
		} else {
			// const orderCartItems = packingSlip ? packingSlip.items : order.cart_items;
			let orderCartItems = [];
			orderCartItems = packingSlip && packingSlip.items ? packingSlip.items : [];
			if (order.cart_items) {
				orderCartItems = order.cart_items;
			}
			orderCartItems.forEach((item, index) => {
				if (index === 0) {
					totalWeight = 0;
				}
				const cartItemWeight = item.weight * item.qty;
				totalWeight += cartItemWeight;
			});
		}

		// Bump Weight
		if (hasBump) {
			totalWeight += bumpWeight;
		}

		const bumpName = hasBump ? `${order.bump.name} (x1)` : '';

		const addressDetails = [];

		const subdistrict = customer.district ? customer.district : customer.subdistrict_name;
		const subdistrictLabel = `Kec. ${subdistrict}`;

		if (subdistrict && subdistrict !== '') {
			addressDetails.push(subdistrictLabel);
		}

		if (customer.city) {
			addressDetails.push(customer.city);
		} else if (customer.city_name) {
			addressDetails.push(customer.city_name);
		}

		const addressDetailsString = addressDetails.join(', ');

		const phone = customer.phone ? `Telp: ${customer.phone}` : '';
		let storeName = store.name ? store.name : '';

		let storePhone = '';
		if (isSenderPhoneVisible) {
			storePhone = store.phone ? store.phone : '';
		}
		// const storeWebsite = store.website ? store.website : '';

		// Dropship
		const isDropship = order.dropship && order.dropship.enabled;
		const dropshipperName = isDropship ? order.dropship.name : '';
		const dropshipperPhone = isDropship ? order.dropship.phone : '';

		if (isDropship) {
			isShowLogo = false;
			storeName = dropshipperName;
			storePhone = dropshipperPhone;
			isSenderAddressVisible = false;
		}

		const csId = order.belongs_to && order.belongs_to.length > 0 ? order.belongs_to[0].$oid : 0;
		const customerService = members.find(({ _id }) => _id === csId);
		const csName = customerService ? customerService.name : '';
		const csPhone = customerService ? customerService.phone : '';

		const replacements = [
			{ key: 'cs_name', value: csName },
			{ key: 'cs_phone', value: csPhone },
		];

		for (let index = 0; index < replacements.length; index++) {
			const replacement = replacements[index];
			const token = `{{${replacement.key}}}`;
			const regex = new RegExp(token, 'g');
			storeName = storeName.replace(regex, replacement.value);
			storePhone = storePhone.replace(regex, replacement.value);
		}

		const orderId = `#${order.order_id}`;

		// let shipment = order.shipping.courier ? `${order.shipping.courier.toUpperCase()} - ${order.shipping.service}` : '';
		let courier = order.shipping.courier ? order.shipping.courier.toUpperCase() : '';
		let courierService = order.shipping.service ? order.shipping.service : '';
		let shippingCost = order.shipping.cost;
		const receiptNumber = order.shipping.receipt_number && order.shipping.receipt_number !== '' ? order.shipping.receipt_number : false;
		const receiptLabel = `NO. RESI: ${order.shipping.receipt_number}`;

		// Check The Mandatory Items
		// const isMandatory = (shippingCourier === 'sicepat' || shippingCourier === 'jne') && (isCod || isInstant);
		// const isPartnerCourier = (shippingCourier === 'sicepat' || shippingCourier === 'jne' || shippingCourier === 'J&T' || shippingCourier === 'sap');
		// const isValidBankTransfer = paymentMethod === 'bank_transfer' && (order.shipping && order.shipping.pickup);
		// const isMandatory = isPartnerCourier && (isCod || isInstant || isValidBankTransfer);
		const isOrderPickedUp = order && order.shipping && !!order.shipping.pickup;
		const isMandatory = isOrderPickedUp;

		if (!isCourierVisible) {
			isCourierVisible = isMandatory;
		}
		if (!isOoLogoVisible) {
			isOoLogoVisible = isMandatory;
		}
		if (!isCodVisible) {
			isCodVisible = isMandatory;
		}
		if (!isShowBarcode) {
			isShowBarcode = isMandatory;
		}
		// if (!isSenderAddressVisible) {
		// 	isSenderAddressVisible = isMandatory;
		// }
		if (!isShowShipping) {
			isShowShipping = isMandatory;
		}
		if (isShowShippingCost && isMandatory) {
			isShowShippingCost = false;
		}

		if (packingSlip) {
			shippingCourier = packingSlip.shipping.courier || '';
			// shipment = packingSlip.shipping.courier ? `${packingSlip.shipping.courier.toUpperCase()} - ${packingSlip.shipping.service}` : '';
			courier = packingSlip.shipping.courier ? packingSlip.shipping.courier.toUpperCase() : '';
			courierService = packingSlip.shipping.service ? packingSlip.shipping.service : '';
			shippingCost = packingSlip.shipping.cost;
		}

		let notes = customer.notes || '';
		// let notesLines = notes ? doc.splitTextToSize(notes, notesWidth) : [];
		notes = notes.replace(/(?:\r\n|\r|\n)/g, '. '); // Replace New Line with period
		// const maxChar = 40;
		const maxChar = 34;
		let notesLines = notes ? textSplitter(notes, maxChar) : [];
		notesLines = notesLines.length > 3 ? notesLines.slice(0, 3) : notesLines;

		const colWidth = isThermal ? (pageWidth - (leftPadding * 2)) : ((pageWidth - (leftPadding * 2)) / 2) - 5;
		const boxPadding = isSmall ? 2 : 5;
		const boxPaddingX = isSmall ? 5 : 8;

		const topBorderX = baseX + leftPadding;
		const topBorderY = baseY + topPadding;

		const topBorderX2 = topBorderX + colWidth;

		// Set Border color
		doc.setDrawColor(50, 50, 50);

		// Top Border
		doc.line(topBorderX, topBorderY, topBorderX2, topBorderY);

		// Ostock Logo
		const logoMargin = isSmall ? 4 : 10;
		const ooLogoHeight = isSmall ? 7 : 10;
		const ooLogoWidth = ooLogo ? (ooLogoHeight / ooLogo.height) * ooLogo.width : 0;
		// const ooLogoX = topBorderX2 - boxPadding - ooLogoWidth;
		const ooLogoX = topBorderX + boxPaddingX;
		const ooLogoY = topBorderY + boxPadding + 5;

		const isHasOoLogo = isOoLogoVisible && ooLogo;

		// OO Logo
		if (isHasOoLogo) {
			doc.addImage(ooLogo.data, 'PNG', ooLogoX, ooLogoY, ooLogoWidth, ooLogoHeight);
		}

		// COD Label
		const xPosCodLabel = topBorderX2 - boxPaddingX;
		const yPosCodLabel = topBorderY + boxPadding + boxPadding + 9;

		if (isCodVisible) {
			doc.setFontType('bold');
			const orderTotal = formatMoney(grossRevenue, 'IDR', true);
			const codLabel = isCod ? `COD: ${orderTotal}` : 'NON-COD';
			const codFontSize = isSmall ? 9 : 11;
			doc.setFontSize(codFontSize);
			doc.text(codLabel, xPosCodLabel, yPosCodLabel, { align: 'right' });
			doc.setFontSize(normalFontSize);
			doc.setFontType('normal');
		}

		const bottomBorderOffset = 10;
		let topBorder2Y = topBorderY + ooLogoHeight + logoMargin + bottomBorderOffset;

		// Border After Logo
		// doc.line(topBorderX, topBorder2Y, topBorderX2, topBorder2Y);

		const leftPos = topBorderX + boxPaddingX;

		doc.setFontSize(normalFontSize);

		// JX Special Layout + Data
		if (shippingCourier === 'jx' && labelData) {
			// Border After Logo
			doc.line(topBorderX, topBorder2Y, topBorderX2, topBorder2Y);

			const extraFontSize = isSmall ? 4 : 6;
			// const barcodeWidth = isSmall ? 70 : 100;
			// const barcodeHeight = isSmall ? 18 : 35;
			const barcodeAwbHeight = isSmall ? 18 : 42.5197; // 1.5cm
			const jxBarcodeAwbWidth = isSmall ? 100 : 170.079; // 6cm
			const jxExtraFontSize = 8.5;

			const jxPackageCode = labelData.packageCode || '';
			const packageCodeBarcode = Object.assign({}, barcodeOptions, { displayValue: false, width: 3 });
			const packageCodeBarcodeImage = generateBarcode(jxPackageCode, packageCodeBarcode);
			const xPosJxPackageCode = baseX + colWidth - jxBarcodeAwbWidth;
			const barcodeAwbOffset = isSmall ? 0 : 3;
			const jxYPosBarcodeAwb = topBorder2Y + barcodeAwbOffset;
			const xPosAwb = baseX + colWidth;
			const yPosAwb = jxYPosBarcodeAwb + barcodeAwbHeight + 3;

			doc.setFontSize(extraFontSize);

			doc.addImage(packageCodeBarcodeImage, 'PNG', xPosJxPackageCode, jxYPosBarcodeAwb, jxBarcodeAwbWidth, barcodeAwbHeight);
			doc.text(`${jxPackageCode}`, xPosAwb, yPosAwb, { align: 'right' });

			doc.setFontType('bold');

			doc.setFontSize(jxExtraFontSize);

			// Origin Sort Center
			const jxOrigSortCenter = labelData.origSortCenter || '';
			const jxOrigCrossCode = labelData.origCrossCode || '';
			const jxOrigTableTrolleyCode = labelData.origTabletrolleyCode || '';
			const jxOrigCross = `${jxOrigCrossCode}-${jxOrigTableTrolleyCode}`;
			const yPosOrigSortCenter = topBorder2Y + 12;
			const yPosOrigCrossCode = yPosOrigSortCenter + lineHeight;
			doc.text(`${jxOrigSortCenter}`, leftPos, yPosOrigSortCenter);
			doc.text(`${jxOrigCross}`, leftPos, yPosOrigCrossCode);

			// Destination Sort Center
			const jxDestSortCenter = labelData.destSortCenter || '';
			const jxDestCrossCode = labelData.destCrossCode || '';
			const jxDestTableTrolleyCode = labelData.destTabletrolleyCode || '';
			const jxDestCross = `${jxDestCrossCode}-${jxDestTableTrolleyCode}`;
			const yPosDestSortCenter = yPosOrigSortCenter + lineHeight + 12;
			const yPosDestCrossCode = yPosDestSortCenter + lineHeight;
			doc.text(`${jxDestSortCenter}`, leftPos, yPosDestSortCenter);
			doc.text(`${jxDestCross}`, leftPos, yPosDestCrossCode);

			topBorder2Y = yPosAwb + 5;
			yPosBorder = topBorder2Y;

			// doc.setFontType('normal');
			// doc.setFontSize(normalFontSize);

			// Border Bottom
			doc.line(topBorderX, yPosBorder, topBorderX2, yPosBorder);

			// Count
			const jxPackageNum = labelData.packageNum || '';
			const jxPackageCount = labelData.packageCount || '';
			const jxCount = `${jxPackageNum}/${jxPackageCount}`;
			const yPosJxCount = topBorder2Y + 10;
			let xPosJxCount = pageWidth / 2;
			if (template === 'boxed') {
				xPosJxCount = pageWidth / 4;
			}

			doc.text(`${jxCount}`, xPosJxCount, yPosJxCount, 'center');

			// Origin City
			const originCity = labelData.sendCity ? labelData.sendCity : '';
			const originCityLabel = `Origin City: ${originCity}`;
			doc.setFontSize(7);
			doc.text(originCityLabel, leftPos, yPosJxCount, { align: 'left' });

			// Site Name
			const siteName = labelData.siteName ? labelData.siteName : '';
			doc.setFontSize(jxExtraFontSize);
			doc.text(siteName, xPosAwb, yPosJxCount, { align: 'right' });

			topBorder2Y = yPosJxCount + 5;

			doc.setFontType('normal');
			doc.setFontSize(normalFontSize);
		}

		// Order ID
		const orderIdOffsetTop = isSmall ? 8 : 15;
		let yPosOrderId = topBorder2Y;
		if (!isSmall) {
			yPosOrderId = topBorder2Y + orderIdOffsetTop;
			doc.text(orderId, leftPos, yPosOrderId);
		}

		// Courier Logo
		const courierOffsetTop = isSmall ? 5 : 10;
		const yPosCourierLogo = yPosOrderId + courierOffsetTop;
		if (shippingCourier === 'J&T') shippingCourier = 'jnt';
		const courierLogo = courierLogos.find(({ key }) => key === shippingCourier);
		let courierLogoWidth = isSmall ? 35 : 50;
		if (shippingCourier === 'jx') {
			courierLogoWidth = isSmall ? 30 : 40;
		}

		if (shippingCourier === 'sap') {
			courierLogoWidth = isSmall ? 30 : 40;
		}

		let courierLogoHeight = courierLogo ? (courierLogoWidth / courierLogo.width) * courierLogo.height : 0;

		if (shippingCourier === 'jnt') {
			courierLogoHeight = isSmall ? 12 : 27;
		}
		if (shippingCourier === 'idexpress') {
			courierLogoWidth = isSmall ? 28 : 40;
			courierLogoHeight = isSmall ? 20 : 25;
		}
		// const xPosCourierLogo = pageWidth - 70 - (courierLogoWidth / 2);
		const xPosCourierLogo = leftPos;
		// const shippingColumnWidth = xPosCourierLogo + courierLogoWidth + 25;
		const shippingColumnWidth = xPosCourierLogo + courierLogoWidth + 10;
		const yPosShippingCost = yPosCourierLogo;
		// const yPosWeight = yPosCourierLogo + courierLogoHeight + 25;
		const weightOffsetTop = isSmall ? 10 : 15;
		const yPosWeight = yPosCourierLogo + courierLogoHeight + weightOffsetTop;
		const yPosWeightValue = yPosWeight + lineHeight;

		// Shipment
		if (isShowShipping) {
			const yPosCourier = yPosOrderId + lineHeight + newLineMargin;
			const yPosCourierService = yPosCourier + lineHeight;

			// Courier Logo
			if (isCourierVisible && courierLogo) {
				doc.addImage(courierLogo.data, 'PNG', xPosCourierLogo, yPosCourierLogo, courierLogoWidth, courierLogoHeight);
			}

			// doc.setFontSize(8);

			// Weight
			if (isWeightVisible) {
				const isCeil = totalWeight % 1000 > 300;
				const weightKg = totalWeight / 1000;
				let totalWeightKg = isCeil ? Math.ceil(weightKg) : Math.floor(weightKg);
				if (totalWeightKg <= 0) totalWeightKg = 1;
				const weightLabel = `${totalWeightKg} Kg`;
				doc.setFontType('normal');
				doc.text('Berat:', leftPos, yPosWeight);
				doc.setFontType('bold');
				doc.text(weightLabel, leftPos, yPosWeightValue);
				doc.setFontType('normal');
			}

			// Courier and Service
			doc.text(courier, shippingColumnWidth, yPosCourier);
			doc.setFontType('bold');
			doc.text(courierService, shippingColumnWidth, yPosCourierService);
			doc.setFontType('normal');

			// const xPosShippingCost = shippingColumnWidth;
			const xPosShippingCost = leftPos + 20;

			// Shipping Cost
			if (isShowShippingCost && shippingCost && shippingCost !== 0) {
				const shippingCostLabel = `${formatMoney(shippingCost, 'IDR', true)}`;
				doc.text('Ongkir:', xPosShippingCost, yPosWeight);
				doc.setFontType('bold');
				doc.text(shippingCostLabel, xPosShippingCost, yPosWeightValue);
				doc.setFontType('normal');
			}

			// Insurance
			const isInsuranceVisible = shippingCourier === 'sicepat';
			if (isInsuranceVisible) {
				const xPosInsurance = xPosShippingCost + 45;
				const yPosInsuranceLabel = yPosWeight;
				const yPosInsurance = yPosInsuranceLabel + lineHeight;
				const insuranceLabel = 'Asuransi:';
				const insuranceValue = '0';
				doc.text(insuranceLabel, xPosInsurance, yPosInsuranceLabel);
				doc.setFontType('bold');
				doc.text(insuranceValue, xPosInsurance, yPosInsurance);
				doc.setFontType('normal');
			}
		}

		let yPosLatest = yPosWeightValue + 10;

		// Show Receipt Number
		if (receiptNumber && !isShowBarcode) {
			const yPosReceiptText = yPosLatest + 6;
			// doc.text(receiptLabel, rightColPos, yPosReceiptNumber);
			doc.text(receiptLabel, leftPos, yPosReceiptText);
			yPosLatest = yPosReceiptText + 5;
		}

		// Order Barcode
		if (isShowBarcode) {
			const barcodeValue = order.order_id;
			const orderIdBarcodeOptions = Object.assign({}, barcodeOptions, { width: 2 });
			const barcodeImage = generateBarcode(barcodeValue, orderIdBarcodeOptions);
			// const barcodeWidth = 90;
			const barcodeWidth = isSmall ? 70 : 100;
			const barcodeHeight = isSmall ? 18 : 35;
			// const barcodeAwbWidth = isSmall ? 70 : 100;
			const barcodeAwbHeight = isSmall ? 18 : 35;

			// const barcodeWidth = isSmall ? 70 : 90;
			// const barcodeHeight = isSmall ? 18 : 35;
			const barcodeAwbWidth = isSmall ? 70 : 125;
			// const barcodeAwbHeight = isSmall ? 18 : 40;

			// const xPosBarcode = lastColPos;
			const barcodeOffsetTop = isSmall ? 0 : 12;
			const xPosBarcode = baseX + colWidth - barcodeWidth;
			const yPosBarcode = yPosOrderId - barcodeOffsetTop;
			const xPosBarcodeId = baseX + colWidth;
			const barcodeIdOffsetTop = isSmall ? 3 : 5;
			const yPosBarcodeId = yPosBarcode + barcodeHeight + barcodeIdOffsetTop;
			// const yPosBarcode = yPosFragileContent;
			doc.addImage(barcodeImage, 'PNG', xPosBarcode, yPosBarcode, barcodeWidth, barcodeHeight);
			// doc.text(`Order ID: ${order.order_id}`, xPosBarcodeId, yPosBarcodeId, { align: 'right' });

			// AWB / No. Resi
			if (receiptNumber) {
				const barcodeAwbOptions = Object.assign({}, barcodeOptions, { displayValue: false, width: 3 });
				const barcodeAwbImage = generateBarcode(receiptNumber, barcodeAwbOptions);
				const xPosBarcodeAwb = baseX + colWidth - barcodeAwbWidth;
				const barcodeAwbOffset = isSmall ? 0 : 5;
				const yPosBarcodeAwb = yPosBarcodeId + barcodeAwbOffset;
				const xPosAwb = baseX + colWidth;
				const yPosAwb = yPosBarcodeAwb + barcodeAwbHeight + 3;
				// const yPosBarcodeAwb = yPosFragileContent;
				doc.addImage(barcodeAwbImage, 'PNG', xPosBarcodeAwb, yPosBarcodeAwb, barcodeAwbWidth, barcodeAwbHeight);
				doc.text(`Resi: ${receiptNumber}`, xPosAwb, yPosAwb, { align: 'right' });

				yPosLatest = yPosAwb + 5;
			}

			doc.text(`Order ID: ${order.order_id}`, xPosBarcodeId, yPosBarcodeId, { align: 'right' });
		}

		// Border After Logo
		doc.line(topBorderX, topBorder2Y, topBorderX2, topBorder2Y);

		// Customer Address
		const xPosAddressTo = leftPos;
		// const yPosAddressTo = yPosLatest + 15;
		const addressOffsetTop = isSmall ? 3 : 10;
		const yPosAddressTo = yPosLatest + addressOffsetTop;

		const yPos = yPosAddressTo;
		const yPosName = yPos + lineHeight + newLineMargin;
		let yPosAddress = yPosName + lineHeight + newLineMargin;
		let yPosAddressDetails = yPosAddress + lineHeight;
		let yPosPhone = yPosAddressDetails + lineHeight + newLineMargin;

		doc.setFontSize(normalFontSize);
		doc.text('Kepada:', xPosAddressTo, yPosAddressTo);

		// Customer Name
		doc.setFontType('bold');
		doc.text(customer.name, leftPos, yPosName);
		doc.setFontType('normal');

		// Customer Address
		for (let index = 0; index < addressLines.length; index++) {
			const line = addressLines[index];
			doc.text(line, leftPos, yPosAddress);
			if (index !== addressLines.length - 1) {
				yPosAddress += lineHeight;
			}
		}

		yPosAddressDetails = yPosAddress + lineHeight;

		// Customer Address Subdistrict and City
		const addressDetailsLines = textSplitter(addressDetailsString, addressCharacters);
		for (let index = 0; index < addressDetailsLines.length; index++) {
			const line = addressDetailsLines[index];
			doc.text(line, leftPos, yPosAddressDetails);
			if (index !== addressDetailsLines.length - 1) {
				yPosAddressDetails += lineHeight;
			}
		}

		yPosAddressDetails += lineHeight;

		const provinceName = customer.province_name;
		const zipCode = customer.zip || '';
		const provinceLabel = provinceName ? `${customer.province_name} ${zipCode}` : `${zipCode}`;

		yPosPhone = yPosAddressDetails;

		// Customer Province
		if (provinceLabel && provinceLabel !== '') {
			doc.text(provinceLabel, leftPos, yPosAddressDetails);
			yPosPhone = yPosAddressDetails + lineHeight;
		}


		// Customer Phone
		doc.text(phone, leftPos, yPosPhone);


		// insert Unboxing Text
		// adjustUnboxingText(doc, template, isShowProductInformation, isUnboxingInstructions, instructions, yPosPhone, lineHeight);

		// Payment Position
		// let yPosPayment = yPosPhone + topPadding;

		// Shipping
		const yPosSender = yPosAddressTo;
		// let yPosShippingCost = yPosSender + lineHeight + newLineMargin;
		const yPosReceiptNumber = yPosShippingCost + lineHeight + newLineMargin;

		let yPosProductName = yPosOrderId + lineHeight + newLineMargin;
		// let yPosProductVariation = yPosProductName + lineHeight + newLineMargin;

		const rightPosOffset = isSmall ? 0 : 10;
		const storeNameOffset = isSmall ? 5 : 10;
		const rightPos = baseX + (colWidth / 2) + rightPosOffset;
		const xPosStore = isShowLogo ? rightPos + logoWidth + storeNameOffset : rightPos;
		// const xSender = isShowLogo ? leftPadding + logoWidth + 10 : leftPadding;
		const xSender = rightPos;

		const xPosLogo = rightPos;
		const senderOffsetTop = isSmall ? 4 : 7;
		const yPosLogo = yPosSender + senderOffsetTop;

		let yPosNotes = receiptNumber ? yPosReceiptNumber + lineHeight + newLineMargin : yPosReceiptNumber;
		let yPosNotesContent = yPosNotes + lineHeight;

		// const yPosBump = 0;

		// Store Logo
		const isStoreLogoVisible = isShowLogo && storeLogo && storeLogo.data && storeLogo.data !== '';
		if (isStoreLogoVisible) {
			doc.addImage(storeLogo.data, 'PNG', xPosLogo, yPosLogo, logoWidth, logoHeight);
		}

		// Sender
		doc.text('Dari:', xSender, yPosSender);

		const storeProvince = store.shipping.origin.province ? store.shipping.origin.province.name : '';
		const storeCity = store.shipping.origin.city ? store.shipping.origin.city.name : '';
		const storeSubdistrict = store.shipping.origin.subdistrict ? store.shipping.origin.subdistrict.name : '';
		const storeZip = store.shipping.origin.zip || '';
		const storeAddress = store.address || '';
		const storeAddressDetails = `${storeSubdistrict}, ${storeCity}`;
		const storeAddressProvince = `${storeProvince} ${storeZip}`;

		const yPosStoreName = yPosSender + lineHeight + newLineMargin;
		// const yPosStoreWeb = yPosStoreName + lineHeight + newLineMargin;
		let yPosStoreAddress = yPosStoreName + lineHeight + newLineMargin;

		doc.setFontType('bold');

		// Store Name
		doc.text(storeName, xPosStore, yPosStoreName);

		doc.setFontType('normal');

		let yPosStorePhone = yPosStoreName + lineHeight;

		// Sender Address
		if (isSenderAddressVisible) {
			// Store Website
			// doc.text(storeWebsite, xPosStore, yPosStoreWeb);
			const storeAddressCharacters = isStoreLogoVisible ? 25 : 35;

			// Store Address
			const storeAddressLines = textSplitter(storeAddress, storeAddressCharacters);
			for (let index = 0; index < storeAddressLines.length; index++) {
				const line = storeAddressLines[index];
				doc.text(line, xPosStore, yPosStoreAddress);
				if (index !== storeAddressLines.length - 1) {
					yPosStoreAddress += lineHeight;
				}
			}

			let yPosStoreAddressDetails = yPosStoreAddress + lineHeight;

			// Store Address Details
			const storeAddressDetailsLines = textSplitter(storeAddressDetails, storeAddressCharacters);
			for (let index = 0; index < storeAddressDetailsLines.length; index++) {
				const line = storeAddressDetailsLines[index];
				doc.text(line, xPosStore, yPosStoreAddressDetails);
				if (index !== storeAddressDetailsLines.length - 1) {
					yPosStoreAddressDetails += lineHeight;
				}
			}

			const yPosStoreAddressProvince = yPosStoreAddressDetails + lineHeight;
			yPosStorePhone = yPosStoreAddressProvince + lineHeight;

			// Store Address Province
			doc.text(storeAddressProvince, xPosStore, yPosStoreAddressProvince);
		}

		// Store Phone
		doc.text(storePhone, xPosStore, yPosStorePhone);

		yPosBorder = yPosPhone > yPosStorePhone ? yPosPhone : yPosStorePhone;

		// Notes
		if (isNotesVisible && notesLines.length > 0) {
			const notesOffsetTop = isSmall ? 2 : lineHeight + 5;
			yPosNotes = Number(yPosBorder) + notesOffsetTop;
			yPosNotesContent = yPosNotes;

			doc.setFontType('bold');
			doc.text('Catatan:', leftPos, yPosNotes);
			doc.setFontType('normal');
			for (let index = 0; index < notesLines.length; index++) {
				yPosNotesContent += lineHeight;
				const line = notesLines[index];
				doc.text(line, leftPos, yPosNotesContent);
			}

			yPosBorder = Number(yPosNotesContent);
		}

		// Instructions
		if (template === 'thermal-large' && instructions.length > 0) {
			const instructionOptions = {
				startY: yPosBorder,
				leftX: leftPos,
				rightX: topBorderX2 - leftPadding,
			};
			yPosBorder = insertInstructions(doc, instructionOptions, instructions);
		}

		// Unboxing Instructions
		let yUnboxingBorder = template === 'thermal-small' ? yPosCourierLogo + 20 : yPosBorder + 20;
		if (isUnboxingInstructions) {
			const lastYUnboxing = adjustUnboxingText(doc, template, shippingCourier, isUnboxingInstructions, instructions, yUnboxingBorder, lineHeight, leftPos);
			yUnboxingBorder = lastYUnboxing;
			yPosBorder = template === 'thermal-small' ? yPosBorder : yUnboxingBorder;
		}

		// Product Information
		if (isShowProductInformation) {
			// Product Information Divider
			const dividerOffsetTop = isSmall ? 3 : 12;
			const yPosDivider = yPosBorder + dividerOffsetTop;
			const productNameOffsetTop = isSmall ? 6 : 15;
			yPosProductName = yPosDivider + productNameOffsetTop;

			const productFontSize = isSmall ? 4 : 6;

			doc.setFontSize(productFontSize);
			doc.setLineDash([7, 2]);
			doc.line(topBorderX, yPosDivider, topBorderX2, yPosDivider);
			doc.setLineDash();

			if (!isSmall) {
				doc.text('Produk', leftPos, yPosProductName);

				// yPosProductName += lineHeight + newLineMargin;
				yPosProductName += lineHeight;
				// yPosProductVariation = yPosProductName + lineHeight;
			}

			let totalProducts = 0;
			const products = [];

			if (order.type === 'form') {
				let theProduct = productText;
				totalProducts = quantityValue;
				// Product Name
				// doc.text(productText, leftPos, yPosProductName);

				// Product Variation
				// doc.setFontSize(7);

				if (isAddProductCode) {
					theProduct = `${productText} - ${order?.product_data.code ?? ''}`;
				}

				if (variations.length > 0) {
					totalProducts = 0;
					let variationItems = '';
					const variationsLength = variations.length;
					// Multiple Variations
					variations.forEach((variationItem, index) => {
						const uom = `${order?.product_data?.variations?.prices[index]?.uom?.value ?? ''} ${order?.product_data?.variations?.prices[index]?.uom?.type ?? 1}`;
						const isLastIndex = index === variationsLength - 1;
						let variationItemLabel = `${variationItem.value} (x${variationItem.quantity})`;
						if (isUsePcsInformation) {
							variationItemLabel = `${variationItem.value} (x${uom})`;
							totalPcsProduct += order?.product_data?.variations?.prices[index]?.uom?.value ?? 1;
						}
						// doc.text(variationItemLabel, leftPos, yPosProductVariation);
						// yPosProductVariation += lineHeight;
						variationItems += `${variationItemLabel}`;
						if (!isLastIndex) variationItems += ', ';
						totalProducts += variationItem.quantity;
					});
					theProduct += `, ${variationItems}`;
				} else if (variation && variation !== '') {
					// Single Variation
					// doc.text(variation, leftPos, yPosProductVariation);
					// yPosProductVariation += lineHeight;
					theProduct += `, ${variation}`;
					totalProducts = quantityValue;
				}

				// Use Product Code
				if (isHideProductName) {
					const productSourceId = order?.product_data?.source_id ?? '';
					const theProductCode = productCodes.find(({ _id }) => _id === productSourceId);
					if (theProductCode) {
						theProduct = `${theProductCode.code} ${productQuantity}`;
					}
				}

				products.push(theProduct);

				// Bump
				if (bumpName !== '') {
					products.push(bumpName);
					// yPosBump = yPosProductVariation + newLineMargin + 3;
					// yPosBump = variation === '' && variations.length === 0 ? yPosProductVariation : yPosBump;
					// doc.setFontSize(normalFontSize);
					// doc.text(bumpName, leftPos, yPosBump);
				}
				// yPosBorder = yPosProductName + 5;
			} else {
				const orderCartItems = packingSlip ? packingSlip.items : order.cart_items;
				const submission = selectedSubmissions.find(sub => sub._id === order._id);
				// const totalItems = orderCartItems.length;
				orderCartItems.forEach((item) => {
					const productSupplier = submission?.products?.find(sub => sub?.product_id?.$oid === item?.source_id);
					const uom = getUomByVariation(productSupplier, item);
					const qty = uom && isUsePcsInformation ? uom.value : item.qty;
					let theProduct = '';

					// if (submission?.products.type === 'variable') {
					// 	const qty = submission?.products?.find(sub => sub?.product_id?.$oid === item?.source_id);
					// }
					// const isLastIndex = index === totalItems - 1;
					const hasVariation = !!item.variation;
					let cartItemProductText = hasVariation
						? item.product_name : `${item.product_name} (x${qty})`;
					const cartItemProductVariation = hasVariation
						? `${item.variation.replace(/\|\|/g, ' - ')} (x${qty})` : '';

					if (isUseProductSupplierName) {
						cartItemProductText = hasVariation
							? productSupplier.name : `${productSupplier.name} (x${qty})`;
					}

					theProduct += cartItemProductText;
					// doc.setFontSize(normalFontSize);
					// Product Name
					// doc.text(cartItemProductText, leftPos, yPosProductName);
					// if (!isLastIndex) {
					// 	yPosProductName += lineHeight + 5;
					// }
					if (hasVariation) {
						theProduct += `, ${cartItemProductVariation}`;
						// Product Variation
						// doc.setFontSize(7);
						// Variation
						// doc.text(cartItemProductVariation, leftPos, yPosProductVariation);
						// if (!isLastIndex) {
						// 	yPosProductName = yPosProductVariation + lineHeight + 5;
						// }
					}
					if (!isSmall && item.notes && item.notes !== '') {
						theProduct += `, Catatan: ${item.notes}`;
					}

					// Use Product Code
					if (isHideProductName) {
						// eslint-disable-next-line camelcase
						const productSourceId = item?.source_id ?? '';
						const theProductCode = productCodes.find(({ _id }) => _id === productSourceId);
						if (theProductCode) {
							theProduct = `${theProductCode.code} (x${qty})`;
						}
					}

					products.push(theProduct);

					totalProducts += qty;
					if (isUsePcsInformation) {
						totalPcsProduct += qty;
					}
					// if (!isLastIndex) {
					// 	yPosProductVariation = yPosProductName + lineHeight;
					// }
				});
				// yPosBorder = yPosProductName + lineHeight + 5;
			}

			const productsLabel = products.join('. ');
			// const productsLabelCharacters = 70;
			const productsLabelCharacters = 90;
			const productsLabelLines = textSplitter(productsLabel, productsLabelCharacters);
			let productsLength = productsLabelLines.length;
			let isProductTrimmed = false;
			if (productsLength > 2) {
				productsLength = 2;
				isProductTrimmed = true;
			}
			for (let index = 0; index < productsLength; index++) {
				const isLastIndex = index === productsLength - 1;
				let productLabelLine = productsLabelLines[index];
				if (isLastIndex && isProductTrimmed) {
					productLabelLine = productLabelLine.substring(0, productLabelLine.length - 3);
					productLabelLine += '...';
				}
				doc.text(productLabelLine, leftPos, yPosProductName);
				if (!isLastIndex) {
					yPosProductName += lineHeight;
				}
			}

			// Total Products
			let totalProductsLabel = '';
			if (isUsePcsInformation) {
				totalProductsLabel = `Total Produk: ${totalPcsProduct} pcs`;
			}
			if (!isUsePcsInformation) {
				totalProductsLabel = `Total Produk: ${totalProducts} pcs`;
			}
			const xPosTotalProducts = topBorderX2 - boxPaddingX;
			const totalProductsOffsetTop = isSmall ? 1 : 4;
			const yPosTotalProducts = yPosProductName + lineHeight + totalProductsOffsetTop;
			doc.setFontType('bold');
			doc.text(totalProductsLabel, xPosTotalProducts, yPosTotalProducts, { align: 'right' });
			doc.setFontType('normal');

			yPosBorder = yPosTotalProducts;

			// Total
			if (isDisplayTotal) {
				const xPosTotal = leftPos;
				const yPosTotal = yPosBorder;
				const orderTotal = formatMoney(grossRevenue, 'IDR', true);
				const orderTotalLabel = `Total: ${orderTotal}`;
				doc.setFontType('bold');
				doc.text(orderTotalLabel, xPosTotal, yPosTotal);
				doc.setFontType('normal');
				// yPosBorder += lineHeight + newLineMargin;
			}

			doc.setFontSize(normalFontSize);
		}

		// Fragile Sign
		if (isFragile) {
			const marginRight = 120;
			const xPosFragile = rightColPos + marginRight + 30;
			const xPosFragileTitle = rightColPos + marginRight + 20;
			// const xPosFragileContent = rightColPos + marginRight;

			const yPosFragile = yPosBorder - topPadding - fragileHeight - 5;
			const yPosFragileTitle = yPosFragile + fragileHeight + lineHeight + newLineMargin;
			// const yPosFragile = isShowPayment ? yPosPayment - 4 : yPosSender - 4;
			// const yPosFragileTitle = yPosFragile + fragileHeight + lineHeight + newLineMargin;
			// const yPosFragileContent = yPosFragileTitle + lineHeight;

			doc.addImage(fragileImage, 'PNG', xPosFragile, yPosFragile, fragileWidth, fragileHeight);
			// doc.setFontSize(9);
			doc.setFontType('bold');
			doc.text('FRAGILE', xPosFragileTitle, yPosFragileTitle);
			doc.setFontSize(normalFontSize);
			doc.setFontType('normal');
			// doc.text('JANGAN DIBANTING!!', xPosFragileContent, yPosFragileContent);
		}

		// if (yPosBorder <= lastY) {
		// 	yPosBorder = lastY + 5;
		// }

		const lastBorderOffsetTop = isSmall ? 4 : 10;

		yPosBorder += lastBorderOffsetTop;

		// Border Bottom
		doc.line(topBorderX, yPosBorder, topBorderX2, yPosBorder);

		// Border Bottom
		// doc.line(topBorderX, yPosBorder, topBorderX2, yPosBorder);

		// Left Border
		doc.line(topBorderX, topBorderY, topBorderX, yPosBorder);

		// Right Border
		doc.line(topBorderX2, topBorderY, topBorderX2, yPosBorder);

		// Check if need to add page
		const oneThirdPageHeight = pageHeight / 3;
		const isNeedNewPage = (isThermal && !isLast) || (baseX !== 0 && (yPosBorder >= (pageHeight - oneThirdPageHeight)));
		// const isNeedNewPage = isThermal || (baseX !== 0 && (yPosBorder >= (pageHeight - oneThirdPageHeight)));
		if (isNeedNewPage) {
			doc.addPage(pageFormat);
			baseX = 0;
			baseY = 0;
			// prevBaseY = 0;
		} else {
			// If X Pos is more than half the page width, then the next X pos will be 0
			if (baseX >= (pageWidth / 2) - 100) {
				baseX = 0;
			} else {
				baseX = topBorderX2;
			}
			if (baseX === 0) {
				baseY = Number(yPosBorder);
				if (prevBaseY > baseY) {
					baseY = prevBaseY;
				}
			}
		}
		prevBaseY = yPosBorder;

		generated = {
			baseX,
			baseY,
			prevBaseY,
		};
	}

	return generated;
};
